module.exports = __webpack_public_path__ + "img/strength.c8b32e2a.png";